import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=150a3c34&"
import script from "./mobile.vue?vue&type=script&lang=js&"
export * from "./mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('150a3c34')) {
      api.createRecord('150a3c34', component.options)
    } else {
      api.reload('150a3c34', component.options)
    }
    module.hot.accept("./mobile.vue?vue&type=template&id=150a3c34&", function () {
      api.rerender('150a3c34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/user/modal/tabs/mobile.vue"
export default component.exports